import { type ReactNode, useEffect } from 'react'
import { Navigate, useLocation } from 'react-router-dom'

import { useSessionStore } from '@/auth/sessionStore'

import { Loading } from './Loading'

export function RequireSession({ children }: { children: ReactNode }) {
  const location = useLocation()
  const { status, bootstrap } = useSessionStore()

  useEffect(() => {
    void bootstrap()
  }, [bootstrap])

  if (status === 'idle' || status === 'loading')
    return <Loading label="Checking your session" />
  if (status === 'anonymous') {
    return (
      <Navigate
        to={`/login?next=${encodeURIComponent(location.pathname)}`}
        replace
      />
    )
  }
  return children
}
